// Keep the archive calendar's cached day list honest without asking the server.
//
// GET /archive is not a cheap call — build_calendar reads the player's whole
// result history (a few hundred documents for someone who plays the archive) and
// joins it in Python. So the calendar is fetched ONCE per app start, and a day
// played since then still showed as untouched: guess fifty times, go back, and
// the calendar said "not started". It only came right after restarting the app,
// which for anyone using this as a PWA means closing it entirely.
// Reported on Discord 2026-08-30.
//
// The fix is arithmetic, not a request: after a guess we already hold the date,
// the attempt count and whether it was solved, which is everything a calendar
// cell shows. Patching the cached entry costs nothing and shows up immediately.
//
// It is a local reckoning, so a game played on a second device can still drift
// from it — but the list is fetched once per start anyway, so this only ever
// moves it CLOSER to the server's truth, never further.
export function applyProgress(days, date, attempts, guessed) {
  if (!Array.isArray(days) || !date) return days;
  let touched = false;
  const next = days.map((d) => {
    if (d.date !== date) return d;
    touched = true;
    return { ...d, status: guessed ? "guessed" : "in_progress", attempts };
  });
  // A date the calendar does not list (today's live word is deliberately not in
  // the archive) leaves the list alone rather than inventing a cell for it.
  return touched ? next : days;
}
